import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import { Box, Typography } from '@mui/material'
import { TFnType, useTranslate } from '@tolgee/react'
import { MRT_Column, MRT_RowData } from 'material-react-table'
import { FC, ReactNode } from 'react'

type TomTableOptionalCellProps = {
  renderedCellValue?: ReactNode | null
  defaultValue?: ReactNode | string
}

type TomTableEmptyCellProps = Pick<TomTableOptionalCellProps, 'renderedCellValue'>
type TomTableUnassignedCellProps = Pick<TomTableOptionalCellProps, 'renderedCellValue'>

export const TomTableEmptyCell: FC<TomTableEmptyCellProps> = ({ renderedCellValue }) => (
  <TomTableOptionalCell renderedCellValue={renderedCellValue} defaultValue='-' />
)

export const TomTableUnassignedCell: FC<TomTableUnassignedCellProps> = ({ renderedCellValue }) => {
  const { t } = useTranslate()
  return (
    <TomTableOptionalCell
      renderedCellValue={renderedCellValue}
      defaultValue={
        <Typography variant='body2' color='text.secondary' fontStyle='italic'>
          {t('unassigned', 'Unassigned')}
        </Typography>
      }
    />
  )
}

export const TomTableOptionalCell: FC<TomTableOptionalCellProps> = ({
  renderedCellValue,
  defaultValue,
}) => renderedCellValue ?? defaultValue

export const getMultiSelectRenderBadge = <T extends MRT_RowData>(
  column: MRT_Column<T>,
  t: TFnType,
  placeholder: string,
) => ({
  //this is a workaround to show only how many items are selected
  slotProps: {
    input: {
      endAdornment: null,
    },
    select: {
      autoWidth: false,
      multiple: true,
      sx: {
        minWidth: 142,
        height: 37,
      },
      renderValue: (selected: unknown) => {
        const arr = Array.isArray(selected) ? selected : []
        if (arr.length === 0)
          return (
            <span
              style={{
                opacity: 0.6,
              }}
            >
              {placeholder}
            </span>
          )
        return (
          <Box
            sx={{
              display: 'inline-flex',
              whiteSpace: 'nowrap',
              alignItems: 'center',
              bgcolor: 'grey.500',
              color: 'common.white',
              borderRadius: 0.5,
              px: 1,
              py: 0.25,
              fontWeight: 600,
              fontSize: 12,
            }}
          >
            {`${arr.length} ${t('selected', 'Selected')}`}
            <Box
              component='span'
              onMouseDown={e => e.stopPropagation()}
              onClick={e => {
                e.stopPropagation()
                column.setFilterValue([])
              }}
              sx={{ display: 'inline-flex', alignItems: 'center', ml: 0.5, cursor: 'pointer' }}
              aria-label='clear'
              role='button'
            >
              <CloseRoundedIcon sx={{ fontSize: 16 }} />
            </Box>
          </Box>
        )
      },
    },
  },
})
